"use client";

import { BSRSearch } from "./bsr/BSRSearch";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Search as LegacySearch } from "./legacy/Search";

export const Search = createBSRExperimentIcon(LegacySearch, BSRSearch);
